import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto text-center">
        <p>&copy; 2024 Car Wash & Rental. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
